import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { ProgramType } from '../../../../api/types/programs/program.type';

export const updateProgramActionNumberOperation = async (
  branchId: number | undefined,
  programId: number | undefined,
  actionNumber: string,
  setLoading: (loading: boolean) => any,
  programType: ProgramType,
  setProgramType: (program: ProgramType) => any,
) => {
  try {
    if (isNaN(Number(branchId)) || isNaN(Number(programId))) {
      toast.warn(
        'לא ניתן לאתר את מזהה השלוחה או התוכנית המבוקשת, נסה שוב בעוד מספר רגעים',
      );
      return;
    }
    setLoading(true);
    await appApi.updateProgramActionNumber(branchId!, programId!, actionNumber);
    const updatedProgramType = {
      ...programType,
      metadata: {
        ...programType.metadata,
        actionNumber: actionNumber, // Update the action number in metadata
      },
    };
    setProgramType(updatedProgramType);
    toast.success('קוד הפעולה עודכן בהצלחה');
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(
      `updateProgramActionNumberOperation is failed with the error: ${e}`,
    );
    toast.error('עדכון קוד הפעולה נכשל, נסה שוב בעוד מספר רגעים');
  }
};
